import { action, makeObservable, observable, runInAction } from "mobx";
import { DefaultRequestStatus, RequestStatus } from "../../shared/api/RequestStatus";
import customerMeetingsService, {
    CustomerMeetingsService,
} from "../../customerMeetings/service/CustomerMeetingsService";
import { CustomerMeeting } from "./CustomerMeeting";
import { CustomerMeetingFromResponse } from "../service/CustomerMeetingFromResponse";
import { MeetingLogType } from "./MeetingLogType";

export interface MeetingStore {
    meeting: CustomerMeeting;

    requestCancelMeetingRequestStatus: RequestStatus;
    getOriginJoinUrlRequestStatus: RequestStatus;
    loadMeetingRequestStatus: RequestStatus;
    addLogRequestStatus: RequestStatus;

    requestCancelMeeting: (urlHash: string) => Promise<void>;
    getOriginJoinUrl: (urlHash: string) => Promise<string | null>;
    loadMeeting: (urlHash: string) => void;
    addLog: (meetingId: string, logType: MeetingLogType) => void;
}

export class DefaultMeetingStore implements MeetingStore {
    constructor(
        private service: CustomerMeetingsService,
        private requestCancelMeetingReqStatus: RequestStatus,
        private getOriginJoinUrlReqStatus: RequestStatus,
        private loadMeetingReqStatus: RequestStatus,
        private addLogReqStatus: RequestStatus
    ) {
        makeObservable(this, {
            requestCancelMeeting: action,
            getOriginJoinUrl: action,
            meeting: observable,
        });
    }

    public meeting: CustomerMeeting = {} as CustomerMeeting;

    public get requestCancelMeetingRequestStatus() {
        return this.requestCancelMeetingReqStatus;
    }

    public get getOriginJoinUrlRequestStatus() {
        return this.getOriginJoinUrlReqStatus;
    }

    public get loadMeetingRequestStatus() {
        return this.loadMeetingReqStatus;
    }

    public get addLogRequestStatus() {
        return this.addLogReqStatus;
    }

    public async requestCancelMeeting(urlHash: string) {
        await this.requestCancelMeetingReqStatus.handleAnyRequest(() =>
            this.service.requestCancelMeeting({ urlHash: urlHash })
        );
    }

    public async getOriginJoinUrl(urlHash: string) {
        return await this.getOriginJoinUrlReqStatus.handleAnyRequest(() =>
            this.service.getOriginJoinUrl({ urlHash: urlHash })
        );
    }

    public async loadMeeting(urlHash: string) {
        var fetchedMeeting = await this.loadMeetingReqStatus.handleAnyRequest(() =>
            this.service.getMeeting({ urlHash: urlHash })
        );

        runInAction(() => {
            if (fetchedMeeting) {
                this.meeting = new CustomerMeetingFromResponse(fetchedMeeting).customerMeeting();
            }
        });
    }

    public async addLog(meetingId: string, logType: MeetingLogType) {
        await this.addLogReqStatus.handleAnyRequest(() => this.service.addLog({ meetingId, logType }));
    }
}

const meetingStore = new DefaultMeetingStore(
    customerMeetingsService,
    new DefaultRequestStatus(),
    new DefaultRequestStatus(),
    new DefaultRequestStatus(),
    new DefaultRequestStatus()
);
export default meetingStore;
